import React, { useState } from 'react';
import {
  Box,
  FormControl,
  MenuItem,
  Select,
  Stack,
  Typography,
  InputLabel,
  OutlinedInput,
  Tooltip
} from '@mui/material';
import LineWeightIcon from '@mui/icons-material/LineWeight';

const strokeWidths = [2, 4, 6, 8];

const StrokeWidth = ({ onWidthChange, defaultWidth = 2 }) => {
  const [selectedWidth, setSelectedWidth] = useState(defaultWidth);

  const handleChange = (e) => {
    const newWidth = e.target.value;
    setSelectedWidth(newWidth);
    onWidthChange?.(newWidth);
  };

  return (
    <Box>
      <FormControl size="small" fullWidth>
        <Select
          labelId="stroke-width-label"
          value={selectedWidth}
          onChange={handleChange}
          label="Width"
          sx={{
            // Target the notchedOutline class for all states (default, hover, focused)
            '& .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&:hover .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
            '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
              border: 'none',
            },
          }}
          renderValue={() => (
            <Tooltip title="Wire Stroke Width">
              <Box style={{ display: "flex", gap: "10px", margin: "0px" }}>
                <LineWeightIcon sx={{ transform: 'scaleY(-1)', color: 'text.secondary' }} />
                <div>{selectedWidth}px</div>
              </Box>
            </Tooltip>
          )}
        >
          {strokeWidths.map((w) => (
            <MenuItem key={w} value={w}>
              <Stack direction="row" alignItems="center" spacing={2} width="100%">
                <Typography>{w}px</Typography>
                <Box
                  sx={{
                    height: `${w}px`,
                    backgroundColor: 'black',
                    width: 80,
                    borderRadius: 1,
                  }}
                />
              </Stack>
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default StrokeWidth;
